export default __webpack_public_path__ + "static/media/left_infographic.ca0f4a19.svg";